import { request } from '@/utils/request'

export const JobRolesService = {
    async get(id) {
        return request.get(`/api/manage/job-roles/${id}`)
    },
    async update(id, role) {
        return request.put(`/api/manage/job-roles/${id}`, role)
    },
}
